import Vuelidate from 'vuelidate';
export default (function (_ref) {
  var Vue = _ref.Vue;
  Vue.prototype.$validationOK = {
    OK: function OK() {
      return true;
    }
  };
  Vue.use(Vuelidate);
});